var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v(" 陕ICP备16014677号 Copyright "),_c('a-icon',{attrs:{"type":"copyright"}}),_vm._v(" 2020 "),_c('span',[_vm._v("西安寻寓信息科技有限公司")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }